import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const HomePage: React.FC = () => {
    const [username, setUsername] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [error, setError] = useState<string>('')
    const [googleAdvertiseMessage, setGoogleAdvertiseMessage] = useState<string>('')

    const { t } = useTranslation()

    useEffect(() => {
        const urlParams = new URL(window.location.href).searchParams

        if (urlParams.get('client_id') === 'meta-action-google-id') {
            setGoogleAdvertiseMessage(t('accountLinking.googleAlerts').toString())
        }

        setError(t('accountLinking.title').toString())
    }, [])

    const login = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        const urlParams = new URL(window.location.href).searchParams

        try {
            const redirectUrl = await axios
                .post(
                    'https://chcloud.it/authorize/',
                    {
                        username,
                        password,
                        redirect_uri: urlParams.get('redirect_uri'),
                        state: urlParams.get('state'),
                        client_id: urlParams.get('client_id')
                    },
                    {
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json'
                        }
                    }
                )
                .then((res) => res.data)

            if (redirectUrl.redirectUri !== undefined) {
                window.location.replace(redirectUrl.redirectUri)
            } else {
                setError(t('accountLinking.box.title').toString())
            }
        } catch (e) {
            console.log('Login error: ', e)
            setError(t('login.loginPage.loginErrorMessage').toString())
        }
    }

    return (
        <div className="container h-100">
            <div className="d-flex justify-content-center h-100">
                <div className="user_card">
                    <div className="d-flex justify-content-center">
                        <div className="brand_logo_container">
                            <img src="https://chcloud.it/loginpage/cherubini_logo.png" alt="Logo" />
                        </div>
                    </div>
                    <div className="d-flex justify-content-center form_container">
                        <form onSubmit={(event) => login(event)}>
                            <div className="mt-1">
                                <div
                                    className="d-flex justify-content-center"
                                    style={{
                                        color: 'white',
                                        textAlign: 'center'
                                    }}
                                >
                                    {error}
                                </div>
                            </div>
                            <div className="mt-2">
                                <div
                                    className="d-flex justify-content-center"
                                    style={{
                                        color: 'white',
                                        textAlign: 'center',
                                        fontSize: 'x-small'
                                    }}
                                >
                                    {googleAdvertiseMessage}
                                </div>
                            </div>
                            <div className="input-group mb-3"></div>

                            <div className="input-group mb-3">
                                <div className="input-group-append">
                                    <span className="input-group-text">
                                        <i className="fas fa-user"></i>
                                    </span>
                                </div>

                                <input
                                    type="text"
                                    id="username"
                                    className="form-control input_user"
                                    value={username}
                                    onChange={(val) => setUsername(val.target.value)}
                                    placeholder={t('login.loginPage.username').toString()}
                                />
                            </div>
                            <div className="input-group mb-3">
                                <div className="input-group-append">
                                    <span className="input-group-text">
                                        <i className="fas fa-key"></i>
                                    </span>
                                </div>

                                <input
                                    type="password"
                                    id="password"
                                    className="form-control input_user"
                                    value={password}
                                    onChange={(val) => setPassword(val.target.value)}
                                    placeholder={t('login.loginPage.password').toString()}
                                />
                            </div>

                            <div className="d-flex justify-content-center mt-3 login_container">
                                <button id="login-btn" type="submit" name="" className="btn login_btn">
                                    {t('login.loginPage.loginButtonText')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomePage
